// src/pages/OrdersPage.js
import React, { useEffect, useState, useRef  } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoadingAnimation from "../components/LoadingAnimation";
function Badge({ text, color }) {
  return (
    <span style={{
      padding: "6px 10px",
      borderRadius: 20,
      background: color,
      color: "#fff",
      fontSize: 13,
      marginLeft: 8
    }}>
      {text}
    </span>
  );
}

export default function OrdersPage() {
   console.log("OrdersPage loaded!");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("accessToken");
  const navigate = useNavigate();
const fetched = useRef(false);

useEffect(() => {
  if (!token) {
    navigate("/customer-dashboard");
    return;
  }

  if (fetched.current) return;
  fetched.current = true;

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/my-orders/");
      setOrders(res.data || []);
    } catch (err) {
      console.error("Orders fetch error:", err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  fetchOrders();
}, []);

  if (loading) return <LoadingAnimation />;

  // categorize current vs past
  const current = orders.filter(o => o.status !== "delivered" && o.status !== "cancelled");
  const past = orders.filter(o => o.status === "delivered" || o.status === "cancelled");

  const statusColor = (status) => {
    if (status === "pending") return "#f59e0b";
    if (status === "processing" || status === "shipped") return "#0ea5e9";
    if (status === "delivered") return "#10b981";
    if (status === "cancelled") return "#ef4444";
    return "#6b7280";
  };

return (
  <div style={{ padding: 40, maxWidth: 1000, margin: "0 auto" }}>
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    marginBottom: "20px",
    flexWrap: "wrap",
  }}
>
  <button
    onClick={() => navigate("/customer-dashboard")}
    style={{
      flex: 1,
      padding: "10px 14px",
      background: "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
    }}
  >
    ⬅ Back to Dashboard
  </button>

  <button
    onClick={() =>
      Swal.fire({
        icon: "info",
        title: "Order Cancellation Policy",
        html: `
          <div style="text-align:left;font-size:14px;line-height:1.6">
            Orders can be cancelled before they are marked as delivered or dispatched for final delivery.<br/><br/>
            
            If you wish to cancel an order, please contact our support team as early as possible.<br/><br/>

            📧 Email: <b>info@pharmahelp.co.in</b>
          </div>
        `,
        confirmButtonColor: "#2563eb",
      })
    }
    style={{
      flex: 1,
      padding: "10px 14px",
      background: "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
    }}
  >
    Cancellation Policy
  </button>
</div>

    <h1>My Orders</h1>

    {/* CURRENT ORDERS */}
    <section style={{ marginTop: 20 }}>
      <h2>Current Orders</h2>

      {current.length === 0 ? (
        <p>No current orders.</p>
      ) : (
        current.map((order) => (

          <div
            key={order.id}
            style={{
              padding: 16,
              marginBottom: 12,
              borderRadius: 8,
              background: "#fff",
              boxShadow: "0 4px 8px rgba(0,0,0,0.04)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <strong>Order #{order.id}</strong>
                <div style={{ fontSize: 13, color: "#6b7280" }}>
                  {new Date(order.created_at).toLocaleDateString()}
                </div>
                <div style={{ fontSize: 13 }}>
                  {order.is_rx ? "Prescription Order" : "Cart Order"}
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <div>
                  <strong>₹ {order.payable_amount || order.total_amount}</strong>
                </div>
                <Badge text={order.status} color={statusColor(order.status)} />
                <div style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>
                  {order.payment_status}
                </div>
              </div>
            </div>

            {/* ITEMS */}
            <div style={{ marginTop: 12 }}>
              {order.is_rx ? (
                <div style={{ color: "#6b7280" }}>
                  Prescription based order
                </div>
              ) : order.items && order.items.length > 0 ? (
                order.items.map((it) => (
                  <div
                    key={it.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      borderTop: "1px solid #f3f4f6",
                    }}
                  >
                    <div>
                      {it.product_name} x {it.quantity}
                    </div>
                    <div>₹ {(it.quantity * it.price).toFixed(2)}</div>
                  </div>
                ))
              ) : (
                <div style={{ color: "#6b7280" }}>No items data.</div>
              )}
            </div>
          </div>
        ))
      )}
    </section>

    {/* PAST ORDERS */}
    <section style={{ marginTop: 30 }}>
      <h2>Past Orders</h2>

      {past.length === 0 ? (
        <p>No past orders.</p>
      ) : (
        past.map((order) => (
          <div
            key={order.id}
            style={{
              padding: 16,
              marginBottom: 12,
              borderRadius: 8,
              background: "#fff",
              boxShadow: "0 4px 8px rgba(0,0,0,0.02)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <strong>Order #{order.id}</strong>
                <div style={{ fontSize: 13, color: "#6b7280" }}>
                  {new Date(order.created_at).toLocaleDateString()}
                </div>
                <div style={{ fontSize: 13 }}>
                  {order.is_rx ? "Prescription Order" : "Cart Order"}
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <div>
                  <strong>₹ {order.payable_amount || order.total_amount}</strong>
                </div>
                <Badge text={order.status} color={statusColor(order.status)} />
              </div>
            </div>

            {/* ITEMS */}
            <div style={{ marginTop: 12 }}>
              {order.is_rx ? (
                <div style={{ color: "#6b7280" }}>
                  Prescription based order
                </div>
              ) : order.items && order.items.length > 0 ? (
                order.items.map((it) => (
                  <div
                    key={it.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      borderTop: "1px solid #f3f4f6",
                    }}
                  >
                    <div>
                      {it.product_name} x {it.quantity}
                    </div>
                    <div>₹ {(it.quantity * it.price).toFixed(2)}</div>
                  </div>
                ))
              ) : (
                <div style={{ color: "#6b7280" }}>No items data.</div>
              )}
            </div>
          </div>
        ))
      )}
    </section>
  </div>
);

}
